module.exports = __webpack_public_path__ + "static/media/abode-wellness-5.918c2c03.jpg";